<template>
    <div>
        <div class="rainDiv">
            <div @click="showFullScreenImage(0)" v-if="detailInfo.pictureUrl">
                <img class="rainPipe" :src="firstImageUrl" />
            </div>
            <div v-else class="rainPipeDiv1">
                <img class="rainPipeImg" src="/gis/noPng.png" />
            </div>
            <div class="rainPipeDivInfo">
                <div class="rainPipeDiv">
                    <div>距离(m)</div>
                    <div>{{ detailInfo.distance }}</div>
                </div>
                <div class="rainPipeDiv">
                    <div>缺陷名称代码</div>
                    <div>{{ detailInfo.defectName }}</div>
                </div>
                <div class="rainPipeDiv">
                    <div>分值</div>
                    <div>{{ detailInfo.score }}</div>
                </div>
                <div class="rainPipeDiv">
                    <div>等级</div>
                    <div>{{ detailInfo.grade }}</div>
                </div>
                <div class="rainPipeDiv">
                    <div>管道内部状况描述</div>
                    <div style="width: 70%;text-align: right;">{{ detailInfo.describe }}</div>
                </div>
                <div class="rainPipeDiv">
                    <div>缺陷点环形位置（时钟）</div>
                    <div>{{ detailInfo.clock }}</div>
                </div>
            </div>
        </div>

        <div v-if="isFullScreen" class="full-screen-image" @click="closeFullScreenImage">
            <div class="image-container">
                <img :src="fullScreenImages[currentIndex].url" alt="Full Screen Image" />
                <div class="image-controls">
                    <button @click="prevImage">&lt;</button>
                    <button @click="nextImage">&gt;</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "rain-pipe-detail-info",
    props: {
        detailInfo: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            isFullScreen: false,
            currentIndex: 0,
            fullScreenImages: []
        };
    },
    computed: {
        firstImageUrl() {
            if (this.detailInfo.pictureUrl) {
                const urls = this.detailInfo.pictureUrl.split(';');
                return urls[0].trim();
            }
            return '';
        }
    },
    watch: {
        'detailInfo.pictureUrl': {
            immediate: true,
            handler() {
                this.updateFullScreenImages();
            }
        }
    },
    methods: {
        closeFullScreenImage() {
            this.isFullScreen = false;
        },
        showFullScreenImage(index) {
            this.currentIndex = index;
            this.isFullScreen = true;
        },
        prevImage(e) {
            e.stopPropagation();
            this.currentIndex = this.currentIndex === 0
                ? this.fullScreenImages.length - 1
                : this.currentIndex - 1;
        },
        nextImage(e) {
            e.stopPropagation();
            this.currentIndex = this.currentIndex === this.fullScreenImages.length - 1 ? 0 : this.currentIndex + 1;
        },
        updateFullScreenImages() {
            if (this.detailInfo.pictureUrl) {
                const urls = this.detailInfo.pictureUrl.split(';').map(url => url.trim());
                this.fullScreenImages = urls.map(url => ({ url }));
            } else {
                this.fullScreenImages = [];
            }
        }
    }
};
</script>

<style scoped>
.rainPipeDiv1{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 120px;
}
.rainPipeImg{
    width: 80px;
    height: 80px;
    opacity: 0.8;
}

.rainPipe {
    width: 120px;
    height: 120px;
    cursor: pointer; /* 添加鼠标悬停效果 */
}
.rainPipeDiv {
    display: flex;
    justify-content: space-between;
}
.rainDiv {
    display: flex;
    justify-content: center;
    font-size: 0.8rem;
    padding: 0.5rem 0;
    border-bottom: 1px dashed #6b6b6b;
}
.rainPipeDivInfo {
    width: 80%;
    margin-left: 1rem;
    color: #adadad;
}


.full-screen-image {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9000;
    overflow: auto;
}

.image-container {
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 关键：子元素（按钮）基于此定位 */
}

.image-container img {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer;
}

.image-container {
    max-width: 90%;
    max-height: 90%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative; /* 用于定位按钮 */
}

.image-container img {
    max-width: 100%;
    max-height: 100%;
    cursor: pointer; /* 添加鼠标悬停效果 */
}

.image-controls {
    position: absolute;
    bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    color: #00B176;
}

.image-controls button {
    margin: 0 10px;
    padding: 5px 10px;
    background-color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}

.image-controls button:hover {
    background-color: #f0f0f0;
}


.image-controls {
    position: absolute;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
}

.image-controls button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    font-size: 18px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background-color 0.3s;
}

.image-controls button:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

.image-controls button:first-child {
    left: 10px;
    position: absolute;
}

.image-controls button:last-child {
    right: 10px;
    position: absolute;
}
</style>